<section class="container mt-5">
    <bn-paginacao [total]="indexadores.length" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="[10, 20, 30]" (aoMudar)="mudancaPagina($event)">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Sigla Indexador</th>
              <th scope="col">Descrição do Indexador</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of indexadores">
              <td>{{ item.nome }}</td>
              <td>{{ item.descricao }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </section>